import type { ComponentType } from "react";
import { MSME_AUTH_MARKETING } from "../../../content/msmeAuthMarketing";
import {
  getMsmeAuthMarketingVariant,
  resolveMarketingBadgeAsset,
  type MsmeAuthMarketingVariant,
} from "../../../../config/sellerOrgConfig";
import { useSellerOrgConfig } from "../../../../Hooks/useSellerOrgConfig";
import type { MsmeAuthMarketingPanelProps } from "./types";
import ColoredCardsPanel from "./variants/ColoredCardsPanel";
import OndcGridPanel from "./variants/OndcGridPanel";

const PANEL_VARIANTS: Record<
  MsmeAuthMarketingVariant,
  ComponentType<MsmeAuthMarketingPanelProps>
> = {
  "colored-cards": ColoredCardsPanel,
  "ondc-grid": OndcGridPanel,
};

const MsmeAuthMarketingPanel = () => {
  const orgConfig = useSellerOrgConfig();
  const variant = getMsmeAuthMarketingVariant(orgConfig);
  const Panel = PANEL_VARIANTS[variant];

  return (
    <Panel
      content={MSME_AUTH_MARKETING}
      subheadline={orgConfig.branding.marketingSubheadline}
      networkBadgeSrc={resolveMarketingBadgeAsset(orgConfig.branding)}
    />
  );
};

export default MsmeAuthMarketingPanel;
